import React, {Component} from 'react';
import {AccountCampaignsConfiguration} from "./AccountCampaignsConfiguration";
import {AccountActionsConfiguration} from "./AccountActionsConfiguration";
import {BudgetConfiguration} from "./BudgetConfiguration";
import {Alert, Card, CardBody, Collapse, Row} from 'reactstrap';
import {FacebookLogo} from "../../logos/FacebookLogo";
import {GoogleLogo} from "../../logos/GoogleLogo";
import {FaIcon} from "../../FaIcon";
import {YesNoModal} from "../../elements/YesNoModal";
import {SheetLogo} from "../../logos/SheetLogo";
import {TYPE_ONE_BUDGET_PER_ADGROUP, TYPE_ONE_BUDGET_PER_CAMPAIGN} from "../BusinessUnitTypes";
import {ANALYTICS_CHANNEL, CHANNEL_INFO_BY_CHANNEL} from "../../channels/channels";
import {Switch} from "../../buttons/Swtich";
import {TiktokLogo} from "../../logos/TiktokLogo";
import {LinkedinLogo} from "../../logos/LinkedinLogo";
import {ShopifyLogo} from "../../logos/ShopifyLogo";
import {TiendaNubeLogo} from "../../logos/TiendaNubeLogo";
import {WooCommerceLogo} from "../../logos/WooCommerceLogo";
import {VtexLogo} from "../../logos/VtexLogo";
import {AnalyticsLogo} from "../../logos/AnalyticsLogo";
import {DV360Logo} from "../../logos/DV360Logo";
import {MercadoAdsLogo} from "../../logos/MercadoAdsLogo";
import {GA4PropertyCard} from "./GA4PropertyCard";
import {ShopifyAccountConfiguration} from "./ShopifyAccountConfiguration";
import {TiendaNubeAccountConfiguration} from "./TiendaNubeAccountConfiguration";
import {AnalyticsAccountConfiguration} from "./AnalyticsAccountConfiguration";
import {GA4FiltersEditor, GA4_AVAILABLE_FIELDS} from "./GA4FiltersEditor";
import {Ga4AttributionSummary} from "./Ga4AttributionSummary";
import {Link} from "react-router-dom";
import {SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL, DV360_CHANNEL, MERCADO_ADS_CHANNEL} from "../../channels/channels";
import { withTranslation } from 'react-i18next';


export const METHOD_ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES = "ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES";
export const METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES = "ECOMMERCE_SELECT_CHANNELS_AND_TYPES";
export const METHOD_ANALYTICS_INCLUDE_ALL_SOURCES_MEDIUMS = "INCLUDE_ALL_ANALYTICS_SOURCE_MEDIUM"
export const METHOD_ANALYTICS_INCLUDE_SOURCE_MEDIUM_ON_CONDITION = "INCLUDE_ANALYTICS_SOURCE_MEDIUM_ON_CONDITION"

// Espejo de constantes del backend (core/models/marketing/agency_ad_account_status.py).
// Si cambia el string en el backend, el FE cae al fallback genérico — no rompe nada.
const BACKEND_ERROR_ACCESS_DENIED = "No tenemos acceso a la cuenta. Verifique la conexión a la plataforma en la configuración de la agencia.";
const BACKEND_ERROR_ACCOUNT_INTERNAL_PROBLEM = "La cuenta tiene un problema. Puede estar des-habilitada.";
const BACKEND_ERROR_CHANNEL_DISCONNECTED = "Se ha desconectado el canal. Vuelva a conectar en la configuración de la agencia.";

const NO_ACCESS_I18N_KEY_BY_BACKEND_ERROR = {
    [BACKEND_ERROR_ACCESS_DENIED]: 'account.no_access_user_permissions',
    [BACKEND_ERROR_ACCOUNT_INTERNAL_PROBLEM]: 'account.no_access_account_disabled',
    [BACKEND_ERROR_CHANNEL_DISCONNECTED]: 'account.no_access_channel_disconnected',
};


class AccountClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen,
            confirmDeleteModalIsOpen: false
        };

        this.handleRolloverChange = this.handleRolloverChange.bind(this);
        this.handleActionsChange = this.handleActionsChange.bind(this);
        this.handleBudgetChange = this.handleBudgetChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleRefreshListItems = this.handleRefreshListItems.bind(this);
        this.handleGA4AccountChange = this.handleGA4AccountChange.bind(this);
        this.handleGA4FiltersChange = this.handleGA4FiltersChange.bind(this);
        this.handleGA4OverwriteConversionsChange = this.handleGA4OverwriteConversionsChange.bind(this);
        this.handleReplacesGlobalConversionsChange = this.handleReplacesGlobalConversionsChange.bind(this);
        this.handleItemsSelectionMethodChange = this.handleItemsSelectionMethodChange.bind(this);
        this.handleItemBudgetChange = this.handleItemBudgetChange.bind((this));
        this.handleItemsSelectionChange = this.handleItemsSelectionChange.bind(this);
        this.handleIncludeTextChange = this.handleIncludeTextChange.bind(this);
        this.handleExcludeTextChange = this.handleExcludeTextChange.bind(this);
        this.handleWeekdayAlertChange = this.handleWeekdayAlertChange.bind(this);
        this.handleWorksOnWeekdayChange = this.handleWorksOnWeekdayChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.openConfirmDeleteModal = this.openConfirmDeleteModal.bind(this);
        this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
        this.handleLoadInactiveCampaigns = this.handleLoadInactiveCampaigns.bind(this);
        this.handleLoadInactiveAdgroups = this.handleLoadInactiveAdgroups.bind(this);
        this.handleAnalyticsFiltersChange = this.handleAnalyticsFiltersChange.bind(this);
        this.handleGa4AttributionSaved = this.handleGa4AttributionSaved.bind(this);
    }

    handleGa4AttributionSaved(attribution) {
        if (this.props.onGa4AttributionSaved) this.props.onGa4AttributionSaved(attribution, this.props.configId);
    }

    openConfirmDeleteModal() {
        this.setState({
            confirmDeleteModalIsOpen: true
        })
    }

    toggle() {
        const isOpen = this.state.isOpen;
        this.setState({
            isOpen: !isOpen
        })
    }

    render() {
        return (
            <div className="section-body-item -wide box account-form">
                <header onClick={this.toggle} className="box-header ad-account">
                    <div className="header-title">
                        {this.platformLogo()}
                        <h2 className="box-title">
                            {this.renderTitle()}
                        </h2>
                    </div>
                    {this.dropDownIcon()}
                </header>
                <Collapse isOpen={this.state.isOpen}>
                    <Card>
                        <CardBody>
                            {this.accountContent()}
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        )
    }

    platformLogo() {
        if (this.props.campaignsConfigurationData.channel === 'FACEBOOK') {
            return <FacebookLogo/>
        } else if (this.props.campaignsConfigurationData.channel === 'GOOGLE') {
            return <GoogleLogo useOld={true}/>
        } else if (this.props.campaignsConfigurationData.channel === 'TIKTOK') {
            return <TiktokLogo/>
        } else if (this.props.campaignsConfigurationData.channel === 'LINKEDIN') {
            return <LinkedinLogo/>
        } else if (this.props.campaignsConfigurationData.channel === SHOPIFY_CHANNEL) {
            return <ShopifyLogo height={20} width={20}/>
        } else if (this.props.campaignsConfigurationData.channel === TIENDA_NUBE_CHANNEL) {
            return <TiendaNubeLogo height={20} width={20}/>
        } else if (this.props.campaignsConfigurationData.channel === WOOCOMMERCE_CHANNEL) {
            return <WooCommerceLogo height={20} width={20}/>
        } else if (this.props.campaignsConfigurationData.channel === VTEX_CHANNEL) {
            return <VtexLogo height={20} width={20}/>
        } else if (this.props.campaignsConfigurationData.channel === ANALYTICS_CHANNEL) {
            return <AnalyticsLogo height={20} width={20}/>
        } else if (this.props.campaignsConfigurationData.channel === DV360_CHANNEL) {
            return <DV360Logo height={20} width={20}/>
        } else if (this.props.campaignsConfigurationData.channel === MERCADO_ADS_CHANNEL) {
            return <MercadoAdsLogo height={20} width={20}/>
        } else {
            return <SheetLogo/>
        }
    }

    dropDownIcon() {
        return <FaIcon className="dropdown-arrow" iconName="chevron-down"/>
    }

    renderTitle() {
        return `${this.props.campaignsConfigurationData.name} ID: ${this.props.campaignsConfigurationData.platform_account_id}`
    }

    renderNoAccessMessage() {
        const { t } = this.props;
        const errorFound = this.props.campaignsConfigurationData.error_found;
        const i18nKey = NO_ACCESS_I18N_KEY_BY_BACKEND_ERROR[errorFound] || 'account.no_access';
        return <div className="col-12"><Alert className="alert-warning filtering-alert">{t(i18nKey)}</Alert></div>
    }

    renderStillDoingFirstSyncing() {
        const { t } = this.props;
        return <div className="col-12"><Alert className="alert-warning filtering-alert">{t('account.first_sync')}</Alert></div>
    }

    accountContent() {
        let innerContent = null;
        if (!this.props.campaignsConfigurationData.ad_account_has_connection)
            innerContent = this.renderNoAccessMessage();
        else if(this.props.campaignsConfigurationData.last_entities_update_on === null)
            innerContent = this.renderStillDoingFirstSyncing();
        else if (this.props.campaignsConfigurationData.channel === SHOPIFY_CHANNEL)
            innerContent = this.renderShopifyContent();
        else if (this.props.campaignsConfigurationData.channel === TIENDA_NUBE_CHANNEL)
            innerContent = this.renderTiendaNubeContent();
        else if (this.props.campaignsConfigurationData.channel === WOOCOMMERCE_CHANNEL)
            innerContent = this.renderWooCommerceContent();
        else if (this.props.campaignsConfigurationData.channel === VTEX_CHANNEL)
            innerContent = this.renderVtexContent();
        else if (this.props.campaignsConfigurationData.channel === ANALYTICS_CHANNEL)
            innerContent = this.renderAnalyticsContent();
        else
            innerContent = this.renderRegularAccountContent()

        return (
            <Row>
                {innerContent}
                <div className="col-12" style={{display: "flex", justifyContent: "flex-end"}}>
                    <YesNoModal onYesAnswer={this.handleDeleteAccount} title={this.props.t('account.delete_config_title')}
                                message={this.props.t('account.delete_config_message')}
                                question={this.props.t('account.delete_config_question')}
                                buttonClassName={"btn -alt -negative"}
                                buttonText={this.props.t('account.remove_button')}
                                buttonIconName={"trash"}
                    />
                </div>
            </Row>
        )
    }

    renderShopifyContent() {
        return (
            <div className="col-12">
                <ShopifyAccountConfiguration
                    adAccountId={this.props.campaignsConfigurationData.ad_account_id}
                    storeId={this.props.campaignsConfigurationData.platform_account_id}
                    selectionMethod={this.props.campaignsConfigurationData.selection_method}
                    selectedChannelsAndTypes={this.props.campaignsConfigurationData.selected_channels_and_types || []}
                    onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onItemsSelectionChange={this.handleShopifyChannelsAndTypesChange}
                />
            </div>
        );
    }

    renderTiendaNubeContent() {
        return (
            <div className="col-12">
                <TiendaNubeAccountConfiguration
                    adAccountId={this.props.campaignsConfigurationData.ad_account_id}
                    storeId={this.props.campaignsConfigurationData.platform_account_id}
                    selectionMethod={this.props.campaignsConfigurationData.selection_method}
                    selectedChannelsAndTypes={this.props.campaignsConfigurationData.selected_channels_and_types || []}
                    onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onItemsSelectionChange={this.handleTiendaNubeChannelsAndTypesChange}
                />
            </div>
        );
    }

    renderWooCommerceContent() {
        return (
            <div className="col-12">
                <div className="section-toggle" style={{ padding: '5px' }}>
                    <a style={{ color: '#B6B6B7', textDecoration: 'none', cursor: 'default' }}>
                        {this.props.t('account.woocommerce_all_traffic_included')}
                    </a>
                </div>
            </div>
        );
    }

    renderVtexContent() {
        return (
            <div className="col-12">
                <div className="section-toggle" style={{ padding: '5px' }}>
                    <a style={{ color: '#B6B6B7', textDecoration: 'none', cursor: 'default' }}>
                        {this.props.t('account.vtex_all_traffic_included')}
                    </a>
                </div>
            </div>
        );
    }

    handleShopifyChannelsAndTypesChange(selectedChannelsAndTypes) {
        if (this.props.onItemsSelectionChange) {
            this.props.onItemsSelectionChange(selectedChannelsAndTypes, null, this.props.configId);
        }
    }

    handleTiendaNubeChannelsAndTypesChange(selectedChannelsAndTypes) {
        if (this.props.onItemsSelectionChange) {
            this.props.onItemsSelectionChange(selectedChannelsAndTypes, null, this.props.configId);
        }
    }

    renderAnalyticsContent() {
        return (
            <div className="col-12">
                <AnalyticsAccountConfiguration
                    selectionMethod={this.props.campaignsConfigurationData.selection_method}
                    ga4Filters={this.props.campaignsConfigurationData.ga4_filters || []}
                    onItemsSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onFiltersChange={this.handleAnalyticsFiltersChange}
                />
                {this.renderActions()}
                {this.renderReplacesGlobalConversions()}
            </div>
        );
    }

    /** El switch que hace que el total de Conversiones de la línea salga de esta cuenta de GA4
     *  en lugar de las cuentas publicitarias (card YKJQUySh). Las consecuencias del cambio se pueden
     *  leer ANTES de activarlo (tooltip del ⓘ), no sólo en el modal de confirmación; y el estado
     *  vigente lleva el mismo rótulo GA4/Ads que el Tablero muestra sobre el total. */
    renderReplacesGlobalConversions() {
        const {t} = this.props;
        const isOn = this.props.campaignsConfigurationData.replaces_global_conversions === true;
        return (
            <div className="form-row switch-input conversions-source-setting">
                <div className="label-with-explanation">
                    <label>
                        {t('account.replaces_global_conversions_label')}
                        <span className="info-icon-container">
                            <FaIcon iconName="info-circle"/>
                            <span className="warning-tooltip -rich">
                                <span className="warning-tooltip-body">
                                    <span className="warning-tooltip-text">
                                        {t('account.replaces_global_conversions_warning')}
                                    </span>
                                </span>
                            </span>
                        </span>
                    </label>
                    <p>
                        <span className={`conversions-source-tag${isOn ? '' : ' -ads'}`}>
                            {isOn ? t('conversions_source.ga4') : t('conversions_source.ads')}
                        </span>
                        <span>{isOn
                            ? t('account.replaces_global_conversions_state_on')
                            : t('account.replaces_global_conversions_state_off')}</span>
                    </p>
                </div>
                <Switch onChange={this.handleReplacesGlobalConversionsChange}
                        checked={isOn}
                        name="replaces_global_conversions"
                        title={t('account.replaces_global_conversions_warning_title')}
                        messageToAlertUserIfChecked={t('account.replaces_global_conversions_warning')}/>
            </div>
        );
    }

    handleAnalyticsFiltersChange(filters) {
        this.props.onAnalyticsFiltersChange(filters, this.props.configId);
    }

    renderRegularAccountContent() {
        return this.renderInnerInputs();
    }

    renderInnerInputs() {
        // A ancho de teléfono las dos columnas se apilan: con `col-6` fijo cada mitad medía 125px a
        // 390 y el editor de filtros GA4 quedaba ilegible (QA-VIS-ga4-01).
        return [
            <div className="col-12 col-lg-6">
                <AccountCampaignsConfiguration
                    onAccountChange={this.handleAccountChange}
                    budgetPerItemModeOn={(this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN || this.props.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP)}
                    allocatedBudgetByItem={this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN ? this.props.campaignsConfigurationData.budget_by_campaign_id : this.props.campaignsConfigurationData.budget_by_adgroup_id}
                    onItemBudgetChange={this.handleItemBudgetChange}
                    onSelectionMethodChange={this.handleItemsSelectionMethodChange}
                    onItemsSelectionChange={this.handleItemsSelectionChange}
                    onIncludeTextChange={this.handleIncludeTextChange}
                    onExcludeTextChange={this.handleExcludeTextChange}
                    itemChannel={this.props.campaignsConfigurationData.channel}
                    accountName={this.props.campaignsConfigurationData.name}
                    lastSyncFormatted={this.props.campaignsConfigurationData.last_entities_update_on_formatted}
                    selectedAccountId={this.props.campaignsConfigurationData.ad_account_id}
                    selectedPlatformAccountId={this.props.campaignsConfigurationData.platform_account_id}
                    adAccountHasConnection={this.props.campaignsConfigurationData.ad_account_has_connection}
                    campaignsSelectionMethod={this.props.campaignsConfigurationData.selection_method}
                    onlyMethodSelectCampaignsFromList={(this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN)}
                    onlyMethodSelectAdgroupsFromList={(this.props.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP)}
                    conditionIncludeText={this.props.campaignsConfigurationData.include_containing}
                    conditionExcludeText={this.props.campaignsConfigurationData.exclude_containing}
                    lastEntitiesUpdatedOn={this.props.campaignsConfigurationData.last_entities_update_on}
                    allActiveCampaigns={this.props.campaignsConfigurationData.all_active_account_campaigns}
                    spendPeriod={this.props.campaignsConfigurationData.spend_period}
                    allActiveAdgroups={this.props.campaignsConfigurationData.all_active_account_adgroups}
                    allNotActiveCampaigns={this.props.campaignsConfigurationData.all_not_active_campaigns}
                    allNotActiveAdgroups={this.props.campaignsConfigurationData.all_not_active_adgroups}
                    selectedCampaigns={this.props.campaignsConfigurationData.selected_campaigns}
                    selectedAdgroups={this.props.campaignsConfigurationData.selected_adgroups}
                    someSelectedNotActiveCampaignsData={this.props.campaignsConfigurationData.some_selected_not_active_campaigns_data}
                    someSelectedNotActiveAdgroupsData={this.props.campaignsConfigurationData.some_selected_not_active_adgroups_data}
                    budgetCurrency={this.props.campaignsConfigurationData.budget_currency}
                    canEditCurrency={this.props.canEditCurrency}
                    selectionMethodsAllowed={this.props.selectionMethodsAllowed}
                    onRefreshListItems={this.handleRefreshListItems}
                    isUpdatingListItems={this.props.isUpdatingListItems}
                    messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                    onLoadInactiveCampaigns={this.handleLoadInactiveCampaigns}
                    onLoadInactiveAdgroups={this.handleLoadInactiveAdgroups}
                    isLoadingInactiveItems={this.props.isLoadingInactiveItems}
                />
                {this.renderGA4Section()}
            </div>,
            <div className="col-12 col-lg-6">
                <BudgetConfiguration allocatedBudget={this.props.campaignsConfigurationData.allocated_budget}
                                     budgetCurrency={this.props.campaignsConfigurationData.budget_currency}
                                     isReadOnly={true}
                                     budgetType={this.props.budgetType}
                                     lastPeriodBalance={this.props.campaignsConfigurationData.last_period_balance}
                                     rollover={this.props.campaignsConfigurationData.rollover}
                                     onRolloverChange={this.handleRolloverChange}
                                     onBudgetChange={this.handleBudgetChange}
                />
                {/*202207: Se comenta porque en el refactoring de chauBU holra Presu esto debería pasar al BU pero
                        por lo que vemos, ninguna agencia activa usa esta funcionalidad en ningun cliente.
                        Por ahora escondemos el front pero queda to.do el codigo en front y back
                    */}
                {/*<DaysOfTheWeekBoleans*/}
                {/*    name={"works_on_weekday"}*/}
                {/*    label={"Las campañas funcionan sólo los días:"}*/}
                {/*    onWeekdayChange={this.handleWorksOnWeekdayChange}*/}
                {/*    monday={this.props.campaignsConfigurationData.works_on_weekday_monday}*/}
                {/*    tuesday={this.props.campaignsConfigurationData.works_on_weekday_tuesday}*/}
                {/*    wednesday={this.props.campaignsConfigurationData.works_on_weekday_wednesday}*/}
                {/*    thursday={this.props.campaignsConfigurationData.works_on_weekday_thursday}*/}
                {/*    friday={this.props.campaignsConfigurationData.works_on_weekday_friday}*/}
                {/*    saturday={this.props.campaignsConfigurationData.works_on_weekday_saturday}*/}
                {/*    sunday={this.props.campaignsConfigurationData.works_on_weekday_sunday}*/}
                {/*/>*/}
                {this.renderActions()}
            </div>];
    }

    renderGA4Section() {
        let elements = [
            <div className="form-header" style={{ marginBottom: '1.5em', marginTop: '2em' }}>
                <h3 className="form-title"><span>GA4</span></h3>
            </div>];

        if(!this.ga4IsEnabled()) {
            const { t } = this.props;
            elements.push(<div className="alert alert-info">{t('account.ga4_consult_team')}</div>);
            return elements;
        }

        // Sin ninguna conexión de GA4 en la agencia, el bloque entero era trabajo que no se puede
        // hacer: un selector vacío y un «Selecciona una propiedad GA4 arriba para poder configurar
        // filtros» que se lee como una tarea pendiente de esta línea, cuando lo que falta es una
        // conexión a nivel agencia. Se dice eso y se ofrece la única acción que destraba.
        //
        // ⚠️ La guarda pide ADEMÁS que no haya propiedad elegida: una línea configurada mientras la
        // conexión existía tiene que seguir mostrando la suya aunque la credencial se haya caído —
        // esconderla haría desaparecer de la pantalla un dato que sigue vigente.
        if(!this.props.ga4IsConnected && !this._hasGA4PropertySelected()) {
            const { t } = this.props;
            elements.push(
                <div key="ga4_not_connected" className="ga4-filters-editor-disabled">
                    {t('account.ga4_not_connected')}
                    {' '}
                    <Link to="/agency/conections">{t('account.ga4_connect_first')}</Link>
                </div>);
            return elements;
        }

        elements = elements.concat([
            <div key="account" className="form-row">
                <label>{this.props.t('account.property')}</label>
                <GA4PropertyCard
                    selectedAccount={this.props.campaignsConfigurationData.ga4_ad_account_account_id}
                    allAccounts={this._getFormattedAllGA4Accounts()}
                    onAccountChange={this.handleGA4AccountChange}
                    addLinkToConnectOption={!this.props.ga4IsConnected}
                />
            </div>,
            // Cómo se cruzan sus grupos y anuncios con GA4: de solo lectura (la regla es de la
            // agencia o de la cuenta) y sólo con una propiedad elegida, que es cuando hay algo que cruzar.
            this._hasGA4PropertySelected() && (
                <div key="ga4_attribution" className="form-row">
                    <Ga4AttributionSummary
                        attribution={this.props.campaignsConfigurationData.ga4_attribution}
                        channel={this.props.campaignsConfigurationData.channel}
                        selectionMethod={this.props.campaignsConfigurationData.selection_method}
                        selectedAdgroups={this.props.campaignsConfigurationData.selected_adgroups}
                        accountName={`${this.props.campaignsConfigurationData.name} [${this.props.campaignsConfigurationData.platform_account_id}]`}
                        onSaved={this.handleGa4AttributionSaved}
                    />
                </div>
            ),
            <div key="ga4_filters" className="form-row">
                {this._hasGA4PropertySelected()
                    ? <GA4FiltersEditor
                        filters={this.props.campaignsConfigurationData.ga4_filters || []}
                        availableFields={GA4_AVAILABLE_FIELDS}
                        onChange={this.handleGA4FiltersChange}
                        propertyId={this.props.campaignsConfigurationData.ga4_ad_account_account_id}
                        adAccountId={this.props.campaignsConfigurationData.ad_account_id}
                        channel={this.props.campaignsConfigurationData.channel}
                    />
                    : <div className="ga4-filters-editor-disabled">
                        {this.props.t('ga4_filters.requires_property_hint')}
                    </div>
                }
            </div>
        ]);

        if (this.props.campaignsConfigurationData.ga4_agency_can_overwrite === true) {
            elements.push(
                <div className="row">
                    <div key="overwrite" className="form-row switch-input p-3"
                        style={{ paddingTop: "0", borderBottom: "0" }}>
                        <label>{this.props.t('account.ga4_overwrite_label')}</label>
                        <Switch onChange={this.handleGA4OverwriteConversionsChange}
                            checked={this.props.campaignsConfigurationData.ga4_overwrite_purchase_value_and_convertions}
                            name="ga4_overwrite_purchase_value_and_convertions" />
                    </div>
                </div>
            );
        }

        return elements;
    }

    _hasGA4PropertySelected() {
        const accountId = this.props.campaignsConfigurationData.ga4_ad_account_account_id;
        return accountId !== null && accountId !== undefined && accountId !== '';
    }

    _getFormattedAllGA4Accounts() {
        if (this.props.allGA4Accounts === undefined || this.props.allGA4Accounts === null)
            return [];

        return this.props.allGA4Accounts.map(account => ({ 'id': account.account_id, 'name': account.name, 'has_access': (account.error_found === null || account.error_found === undefined) }));
    }

    ga4IsEnabled() {
        return this.props.ga4IsEnabled;
    }

    renderActions() {
        if (CHANNEL_INFO_BY_CHANNEL[this.props.campaignsConfigurationData.channel]?.hasActions) {

            const ret = [];

            ret.push(
                <div className="form-row">
                    <AccountActionsConfiguration
                        selectedActions={this.props.campaignsConfigurationData.selected_actions}
                        allActions={this.props.campaignsConfigurationData.all_actions}
                        onChange={this.handleActionsChange}
                        hasIncludeAllConversionsSetting={CHANNEL_INFO_BY_CHANNEL[this.props.campaignsConfigurationData.channel]?.hasIncludeAllConversionsSetting}
                        channel={this.props.campaignsConfigurationData.channel}
                        onRefreshListItems={this.handleRefreshListItems}
                        isUpdatingListItems={this.props.isUpdatingListItems}
                        messageForRefreshListItemsIconToolbox={this.props.messageForRefreshListItemsIconToolbox}
                    />
                </div>
            );

            return ret;

        } else {
            return null;
        }
    }

    handleRolloverChange(value) {
        this.props.onRolloverChange(value, this.props.configId)
    }

    handleItemBudgetChange(allocatedBudgetByItemId, selectedCampaigns, selectedAdgroups) {
        this.props.onItemBudgetChange(this.props.configId, allocatedBudgetByItemId, selectedCampaigns, selectedAdgroups);
    }

    handleActionsChange(selectedActions) {
        this.props.onActionsChange(selectedActions, this.props.configId)
    }

    handleBudgetChange(newCurrency, newBudget) {
        this.props.onBudgetChange(newCurrency, newBudget, this.props.configId)
    }

    handleAccountChange(adAccountId, accountName) {
        this.props.onAccountChange(adAccountId, accountName, this.props.configId)
    }

    handleRefreshListItems() {
        this.props.onRefreshItemsList(this.props.configId);
    }

    handleLoadInactiveCampaigns() {
        this.props.onLoadInactiveCampaigns(this.props.configId);
    }

    handleLoadInactiveAdgroups() {
        this.props.onLoadInactiveAdgroups(this.props.configId);
    }

    handleGA4AccountChange(ga4AdAccountId, ga4AccountName) {
        this.props.onGA4AccountChange(ga4AdAccountId, ga4AccountName, this.props.configId)
    }

    handleGA4FiltersChange(filters) {
        this.props.onGA4FiltersChange(filters, this.props.configId)
    }

    handleGA4OverwriteConversionsChange(event) {
        this.props.onGA4OverwriteConversionsChange(event.target.checked, this.props.configId)
    }

    handleReplacesGlobalConversionsChange(event) {
        this.props.onReplacesGlobalConversionsChange(event.target.checked, this.props.configId)
    }

    handleItemsSelectionMethodChange(newValue) {
        this.props.onItemsSelectionMethodChange(newValue, this.props.configId)
    }

    handleItemsSelectionChange(itemsSelected, allocatedBudgetByItemId) {
        this.props.onItemsSelectionChange(itemsSelected, allocatedBudgetByItemId, this.props.configId)
    }

    handleIncludeTextChange(newText, allocatedBudgetByItemId) {
        this.props.onIncludeTextChange(newText, allocatedBudgetByItemId, this.props.configId)
    }

    handleExcludeTextChange(newText, allocatedBudgetByItemId) {
        this.props.onExcludeTextChange(newText, allocatedBudgetByItemId, this.props.configId)
    }

    handleWorksOnWeekdayChange(name, value) {
        this.props.onWorksOnWeekdayChange(name, value, this.props.configId)
    }

    handleWeekdayAlertChange(name, value) {
        this.props.onWeekdayAlertChange(name, value, this.props.configId)
    }

    handleDeleteAccount() {
        this.props.onDeleteAccount(this.props.configId)
    }
}

export const Account = withTranslation()(AccountClass);
